import React, { useEffect, useRef, useState } from 'react'
import NotificationsView from './NotificationsView'
import NotificationAPI from 'api/NotificationAPI'

const Notifications = (props) => {
    const { user, iconColor } = props
    const [notifications, setNotifications] = useState([])
    const [notificationCount, setNotificationCount] = useState(0)
    const [page, setPage] = useState(1)
    const [isLastPage, setIsLastPage] = useState(true)
    const subscriptionRef = useRef(null)

    useEffect(() => {
        startNotificationStream(user)

        return () => {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe()
                subscriptionRef.current = null
            }
        }
    }, [user])

    useEffect(() => {
        getNotifications(page)
    }, [page])

    const startNotificationStream = (user) => {
        // Add safety check for ActionCable availability
        if (!window.App || !window.App.cable) {
            console.error('ActionCable not available yet, retrying in 1 second...')
            setTimeout(() => startNotificationStream(user), 1000)
            return
        }

        console.log('Starting notification stream for user:', user.notification_room_id)

        window.App.cable.subscriptions.create({
            channel: 'NotificationRoomsChannel',
            notification_room_id: user.notification_room_id
        }, {
            connected: function () {
                console.log('Connected to NotificationRoomsChannel for room:', user.notification_room_id)
            },
            disconnected: function () {
                console.log('Disconnected from NotificationRoomsChannel')
            },
            received: function (newNotification) {
                console.log('Received notification:', newNotification)
                const currentNotifications = notifications.filter((notif) => {
                    return notif.id !== newNotification.id
                })
                currentNotifications.unshift(newNotification)
                setNotifications(currentNotifications)

                const newNotificationCount = currentNotifications.filter((notif) => {
                    return !notif.seen
                })
                setNotificationCount(newNotificationCount.length)
            }
        })
    }

    const getNotifications = (page) => {
        const data = { page: page }
        NotificationAPI.GetNotifications(data).then(response => {
            setNotifications(notifications.concat(response.data.notifications))
            setNotificationCount(response.data.notification_count)
            setIsLastPage(response.data.is_last_page)
        })
    }

    const seeNotifications = (notificationIds) => {
        NotificationAPI.SeeNotifications({
            notification_ids: notificationIds
        }).then(response => {
            setNotificationCount(0)
        })
    }

    const loadMore = () => {
        setPage(page + 1)
    }

    return (
        <NotificationsView
            notifications={notifications}
            notificationCount={notificationCount}
            seeNotifications={seeNotifications}
            loadMore={loadMore}
            isLastPage={isLastPage}
            iconColor={iconColor}
        />
    )
}

export default Notifications
